import AppTheme from "./v3/AppTheme";

const defaultCalendarTheme = {
  backgroundColor: AppTheme.DEFAULT_COLOR,
  calendarBackground: AppTheme.DEFAULT_COLOR,
  textSectionTitleColor: "#b6c1cd",
  textSectionTitleDisabledColor: "#d9e1e8",
  selectedDayTextColor: "#925BE8",
  dayTextColor: "#2d4150",
  arrowColor: "#FFF",
  monthTextColor: "#000",
  textDayFontWeight: "400",
  textMonthFontWeight: "bold",
  textDayFontSize: 16,
  textMonthFontSize: 16,
  textDayHeaderFontSize: 16,
};

export const TimepickerCalendarTheme = {
  backgroundColor: "#F3F2F1",
  calendarBackground: "#F3F2F1",
  textSectionTitleColor: "#b6c1cd",
  textSectionTitleDisabledColor: "#d9e1e8",
  selectedDayTextColor: "#F3F2F1",
  dayTextColor: "#2d4150",
  arrowColor: AppTheme.almostBlack,
  monthTextColor: AppTheme.almostBlack,
  textDayFontWeight: "400",
  textMonthFontWeight: "bold",
  textDayFontSize: 16,
  textMonthFontSize: 16,
  textDayHeaderFontSize: 16,
};

export default defaultCalendarTheme;
